import React from 'react'
import MaterialSymbol from '../material-symbol'

const Cloud = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="cloud" {...props} />
))

Cloud.displayName = 'Cloud'

export default Cloud
